// Preserve the old theme's shared logo group when certification data is present.
if (!customElements.get('wat-certifications')) {
  const requests = new Map();

  function hasCertifications(psku) {
    if (!requests.has(psku)) {
      const request = (async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch('https://dashboard.wildner.gmbh/system/watapparel/shopify-product-meta-data.php', {
            method: 'POST',
            body: new URLSearchParams({ psku }),
            credentials: 'omit',
            signal: controller.signal
          });
          if (!response.ok) throw new Error('Product metadata unavailable');
          const data = await response.json();
          const certification = Array.isArray(data) && data[0]?.certification;
          return (typeof certification === 'string' || Array.isArray(certification)) && certification.length > 0;
        } catch {
          requests.delete(psku);
          return false;
        } finally {
          clearTimeout(timeout);
        }
      })();
      requests.set(psku, request);
    }
    return requests.get(psku);
  }

  customElements.define('wat-certifications', class extends HTMLElement {
    async connectedCallback() {
      const psku = this.dataset.psku;
      this.hidden = true;
      if (!psku) return;
      const visible = await hasCertifications(psku);
      if (this.isConnected && this.dataset.psku === psku) this.hidden = !visible;
    }
  });
}
